import { Model } from "src/app/core/data/model";

export class Drawing extends Model {
  constructor() {
    super();
  }
}
